<template>
  <v-menu v-model="menu" offset-y>
    <template v-slot:activator="{ attrs }">
      <v-text-field
        :value="value"
        :label="
          label ||
          (selectedSearchType === 'All Fields'
            ? translations.search[lang]
            : selectedSearchType
              ? translations.searchBy[lang] + selectedSearchType
              : translations.search[lang])
        "
        color="secondary"
        autocomplete="off"
        rounded
        outlined
        dense
        clearable
        hide-details
        :aria-expanded="attrs['aria-expanded']"
        :prepend-inner-icon="icons.mdiMagnify"
        :append-icon="searchTypes ? icons[icon] : ''"
        @input="$emit('input', $event)"
        @change="$emit('change', $event)"
        @click:append="menu = true"
      ></v-text-field>
    </template>

    <v-list dense>
      <v-list-item-group v-model="selectedSearchType" color="secondary">
        <v-list-item v-for="searchType in searchTypes" :key="searchType" :value="searchType">
          <v-list-item-title v-text="searchType"></v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import { mdiMagnify, mdiChevronUp, mdiChevronDown } from '@mdi/js';
import translations from '@/utils/translations/global';

export default {
  name: 'BSearchField',

  mixins: [translations],

  props: {
    value: {
      type: [String, Number],
    },
    label: String,
    searchTypes: Array,
    selectedSearchType: String,
  },

  data: () => ({
    menu: false,
    icons: {
      mdiMagnify,
      mdiChevronUp,
      mdiChevronDown,
    },
  }),

  computed: {
    icon() {
      return this.menu ? 'mdiChevronUp' : 'mdiChevronDown';
    },

    lang() {
      return this.$route.params.lang;
    },
  },
};
</script>
